module.exports = ".split {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: yellow;\n}\n.split .fixed-panel {\n  width: 50%;\n  height: 100%;\n  position: sticky;\n  overflow-y: auto;\n  top: 0;\n}\n.split .scrolling-panels {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  width: 50%;\n  height: 100vh;\n  overflow-y: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/website-template2/website-template2.component.scss
// module id = ./src/app/website-template2/website-template2.component.scss
// module chunks = main